import { useMemo } from 'react';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { Avatar, Box, IconButton, Link, Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import useNumberFormat from 'hooks/useNumberFormat';
import moment from 'moment';
import DataGridPagination from 'components/pagination/DataGridPagination';

const TDSChequeList = ({
  data,
  filterButtonEl,
  total,
  paginationModel,
  setPaginationModel,
  setPayment,
  setOpen,
}) => {
  const { currencyFormat } = useNumberFormat();

  const columns = useMemo(
    () => [
      {
        field: 'action',
        headerName: 'Action',
        filterable: false,
        sortable: false,
        align: 'right',
        width: 60,
        headerAlign: 'right',
        renderCell: (params) => {
          return (
            <IconButton
              onClick={() => {
                setOpen(true);
                setPayment(params.row);
              }}
            >
              <ModeEditOutlineOutlinedIcon />
            </IconButton>
          );
        },
      },
      {
        field: 'client',
        headerName: 'Client',
        minWidth: 240,
        filterable: false,
        sortable: false,
        flex: 1,
        renderCell: (params) => {
          const { firstName, lastName, mobile } = params.row.customerId;

          return (
            <Stack
              sx={{
                gap: 1.5,
                alignItems: 'center',
              }}
            >
              <Avatar
                alt={firstName.toUpperCase()}
                src={firstName}
                sx={{ width: 24, height: 24, bgcolor: '#977efdff' }}
              />
              <div>
                <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                  {`${firstName} ${lastName}`}
                </Typography>
                <Link href="#!" variant="caption">
                  {mobile || ''}
                </Link>
              </div>
            </Stack>
          );
        },
      },
      {
        field: 'amount',
        headerName: 'Amount',
        filterable: false,
        sortable: false,
        minWidth: 150,
        renderCell: (params) => {
          const { amount } = params.row;
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {amount}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'date',
        headerName: 'Date',
        filterable: false,
        sortable: false,
        minWidth: 170,
        flex: 1,
        renderCell: (params) => {
          const { dateOfRecieve } = params.row;
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {moment(dateOfRecieve).format('DD/MM/YYYY')}
              </Typography>
            </Box>
          );
        },
      },

      {
        field: 'audit',
        headerName: 'Last Updated By',
        sortable: false,
        filterable: false,
        minWidth: 150,
        flex: 1,
        renderCell: (params) => {
          const { audit } = params.row;
          return (
            <Stack direction="row" alignItems="center" spacing={1.5}>
              {audit && (
                <Box>
                  <Typography variant="subtitle2">{`${audit?.user.firstName} ${audit?.user.lastName} - ${audit.action}`}</Typography>
                  <Typography variant="caption">
                    {moment(audit.createdAt).format('DD/MM/YYYY HH:mm A')}
                  </Typography>
                </Box>
              )}
            </Stack>
          );
        },
      },
    ],
    [currencyFormat],
  );
  return (
    <Box sx={{ width: '100%' }}>
      <DataGrid
        rowHeight={72}
        rows={data}
        getRowId={(row) => row._id}
        columns={columns}
        pagination
        paginationMode="server"
        rowCount={total}
        paginationModel={paginationModel}
        onPaginationModelChange={(e) =>
          setPaginationModel((prev) => ({
            page: e.page,
            pageSize: e.pageSize,
            search: prev.search,
          }))
        }
        pageSizeOptions={[5, 10, 20]}
        sx={{
          '& .margin': {
            pr: 3,
          },
          '& .MuiDataGrid-columnHeaders': {
            minWidth: '100%',
          },
        }}
        slots={{
          basePagination: (props) => <DataGridPagination showFullPagination {...props} />,
        }}
        slotProps={{
          panel: {
            target: filterButtonEl,
          },
        }}
      />
    </Box>
  );
};

export default TDSChequeList;
